import '@babel/polyfill'
import 'mutationobserver-shim'
import {router} from './router'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import store from './store'
import './plugins/vuetify'
import Sticky from 'vue-sticky-directive'
import header from './header.vue'
import leftNavigator from './leftNavigator.vue'
import parserWrapper from './parser/parser_wrapper.vue'
import meneger from './meneger.vue'
import modalData from './modalData.vue'
import procBinding from './procBinding.vue'
import conditions from './tasks/conditions.vue'
import checkboxMulti from './checkMulti.vue'
import taskLogs from './tasks/logs/wrapper.vue'
// глобальные компоненты х data шаблоны
import pageTemplate from './parser/foundData/pages.vue'
import groupTemplate from './parser/foundData/groups.vue'
import topicTemplate from './parser/foundData/topics.vue'
import videoTemplate from './parser/foundData/videos.vue'
import postTemplate from './parser/foundData/posts.vue'
// глобальные компоненты
Vue.use(Sticky)

Vue.component ('app-header', header)
Vue.component ('app-navigator', leftNavigator)
Vue.component ('app-parser_wrapper', parserWrapper)
Vue.component ('app-meneger', meneger)

// модальные
Vue.component ('app-taskCond', conditions)
Vue.component ('app-modalData', modalData)
Vue.component ('app-procBinding', procBinding)
Vue.component ('app-checkboxMulti', checkboxMulti)
Vue.component ('app-logs', taskLogs)

// глобальные компоненты х data шаблоны
Vue.component ('app-page-template', pageTemplate)
Vue.component ('app-group-template', groupTemplate)
Vue.component ('app-topic-template', topicTemplate)
Vue.component ('app-video-template', videoTemplate)
Vue.component ('app-post-template', postTemplate)

new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
})
